/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceLeaderboardDemoEntry } from './SurfaceLeaderboardDemoEntry';
import {
    SurfaceLeaderboardDemoEntryFromJSON,
    SurfaceLeaderboardDemoEntryFromJSONTyped,
    SurfaceLeaderboardDemoEntryToJSON,
    SurfaceLeaderboardDemoEntryToJSONTyped,
} from './SurfaceLeaderboardDemoEntry';

/**
 * 
 * @export
 * @interface SurfaceLeaderboardBlockConfig
 */
export interface SurfaceLeaderboardBlockConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    competitionId?: string;
    /**
     * Ledger board (ScoreConfig) id — required when source is LEDGER.
     * @type {string}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    scoreConfigId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    source?: SurfaceLeaderboardBlockConfigSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    maxRows?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    showCurrentUser?: boolean;
    /**
     * Pin a "My Position" row at the bottom even when user is outside the top N
     * @type {boolean}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    showMyPosition?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    showPlatformIcons?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    layout?: SurfaceLeaderboardBlockConfigLayoutEnum;
    /**
     * Static entries rendered when source is DEMO. For sales demos and pre-launch hubs.
     * @type {Array<SurfaceLeaderboardDemoEntry>}
     * @memberof SurfaceLeaderboardBlockConfig
     */
    demoEntries?: Array<SurfaceLeaderboardDemoEntry>;
}


/**
 * @export
 */
export const SurfaceLeaderboardBlockConfigSourceEnum = {
    COMPETITION: 'COMPETITION',
    HUB_POINTS: 'HUB_POINTS',
    DEMO: 'DEMO',
    LEDGER: 'LEDGER'
} as const;
export type SurfaceLeaderboardBlockConfigSourceEnum = typeof SurfaceLeaderboardBlockConfigSourceEnum[keyof typeof SurfaceLeaderboardBlockConfigSourceEnum];

/**
 * @export
 */
export const SurfaceLeaderboardBlockConfigLayoutEnum = {
    full: 'full',
    compact: 'compact',
    sidebar: 'sidebar'
} as const;
export type SurfaceLeaderboardBlockConfigLayoutEnum = typeof SurfaceLeaderboardBlockConfigLayoutEnum[keyof typeof SurfaceLeaderboardBlockConfigLayoutEnum];


/**
 * Check if a given object implements the SurfaceLeaderboardBlockConfig interface.
 */
export function instanceOfSurfaceLeaderboardBlockConfig(value: object): value is SurfaceLeaderboardBlockConfig {
    return true;
}

export function SurfaceLeaderboardBlockConfigFromJSON(json: any): SurfaceLeaderboardBlockConfig {
    return SurfaceLeaderboardBlockConfigFromJSONTyped(json, false);
}

export function SurfaceLeaderboardBlockConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceLeaderboardBlockConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'scoreConfigId': json['scoreConfigId'] == null ? undefined : json['scoreConfigId'],
        'source': json['source'] == null ? undefined : json['source'],
        'maxRows': json['maxRows'] == null ? undefined : json['maxRows'],
        'showCurrentUser': json['showCurrentUser'] == null ? undefined : json['showCurrentUser'],
        'showMyPosition': json['showMyPosition'] == null ? undefined : json['showMyPosition'],
        'showPlatformIcons': json['showPlatformIcons'] == null ? undefined : json['showPlatformIcons'],
        'layout': json['layout'] == null ? undefined : json['layout'],
        'demoEntries': json['demoEntries'] == null ? undefined : ((json['demoEntries'] as Array<any>).map(SurfaceLeaderboardDemoEntryFromJSON)),
    };
}

export function SurfaceLeaderboardBlockConfigToJSON(json: any): SurfaceLeaderboardBlockConfig {
    return SurfaceLeaderboardBlockConfigToJSONTyped(json, false);
}

export function SurfaceLeaderboardBlockConfigToJSONTyped(value?: SurfaceLeaderboardBlockConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitionId': value['competitionId'],
        'scoreConfigId': value['scoreConfigId'],
        'source': value['source'],
        'maxRows': value['maxRows'],
        'showCurrentUser': value['showCurrentUser'],
        'showMyPosition': value['showMyPosition'],
        'showPlatformIcons': value['showPlatformIcons'],
        'layout': value['layout'],
        'demoEntries': value['demoEntries'] == null ? undefined : ((value['demoEntries'] as Array<any>).map(SurfaceLeaderboardDemoEntryToJSON)),
    };
}

